import { CheckIcon } from "@heroicons/react/outline";

const features = [
    {
        name: "Weer met een lach in de spiegel kijken",
    },
    {
        name: "Met trots leuke kleding kunnen dragen",
    },
    {
        name: "Zonder schaamte over het strand lopen in zwemkleding",
    },
    {
        name: "Weer een fitte papa of mama voor je kinderen",
    },
    {
        name: "Meer zelfvertrouwen in jezelf en je figuur",
    },
    {
        name: "Geen ‘morgen-begin-ik-echt’ mentaliteit meer",
    },
    {
        name: "Geen jojo-effect meer maar duurzame resultaten",
    },
];

export default ({ classNames }) => {
    return (
        <div className="bg-black">
            <div
                className={`max-w-7xl mx-auto xs:pb-8 sm:pb-8 md:pb-16 lg:pb-16 ${classNames}`}
            >
                <div className="max-w-3xl mx-auto text-center">
                    <h2 className="mt-2 px-4 xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl text-white font-custom italic font-bold uppercase">
                        Zet vandaag de stap naar jouw transformatie!
                    </h2>
                </div>
                <dl className="mt-12 px-4 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 lg:grid-cols-4 lg:gap-x-8">
                    {features.map((feature) => (
                        <div key={feature.name} className="relative">
                            <dt>
                                <CheckIcon
                                    className="absolute h-10 w-10 text-green-500"
                                    aria-hidden="true"
                                />
                                <p className="ml-12 text-lg xs:leading-8 sm:leading-8 md:leading-8 lg:leading-8 text-gray-100">
                                    {feature.name}
                                </p>
                            </dt>
                        </div>
                    ))}
                </dl>
                <div className="text-center">
                    <a
                        href={route('twelve-week-program')}
                        className="mt-24 uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-black hover:text-white bg-we-are-yellow hover:bg-we-are-purple focus:outline-none focus:ring-2 focus:ring-offset-2"
                    >
                        Meer informatie
                    </a>
                </div>
            </div>
        </div>
    );
};
